import React from 'react'
import { Modal } from 'react-bootstrap'
import { InlineWidget } from 'react-calendly'
import LogoImageMobile from '../../Images/logo-mobile.png';
import styles from './styles.module.css';


interface CalendlyProps {
  consultationModal: boolean
  setConsultationModal: (value: boolean) => void
}

const Calendly: React.FC<CalendlyProps> = ({
  consultationModal,
  setConsultationModal,
}) => {
  return (
    <Modal show={consultationModal} onHide={() => setConsultationModal(false)}>
      <Modal.Header closeButton className={styles.head}>
        {LogoImageMobile && <img src={LogoImageMobile} alt="Logo" />}
      </Modal.Header>
      <Modal.Body>
        <InlineWidget url="https://calendly.com/breathe-ev-info/30min" />
      </Modal.Body>
    </Modal>
  )
}

export default Calendly
